export const template = {
  headerScroll: '',
  drawer: false
};

export const templateGetters = {
  getTempalte: state => {
    return state.template;
  },
  getDrawer: state => {
    return state.drawer;
  }
};

export const templateMutations = {
  changeTemplate(state, value) {
    state.template = value;
  },
  changeDrawer(state) {
    state.drawer = !state.drawer;
  },
};

export const templateActions = {
  act_toggleDrawer: ({ commit }) => {
    commit("changeDrawer");
  }
};
